import first from 'lodash/first';
import get from 'lodash/get';
import { useCallback } from 'react';

type ParentElement = HTMLElement | Document;

export const useTarget = () => {
  const isSafari = get(window, 'navigator.vendor', '').startsWith('Apple');
  const behavior = isSafari ? 'auto' : 'smooth';
  const getTarget = useCallback((target: string, parent: ParentElement = document) => parent?.querySelector(`[data-target='${target}']`) as HTMLElement, []);

  const scrollTo = useCallback((target: string, block: ScrollLogicalPosition = 'start') => {
    let el;

    if (target) {
      el = getTarget(target);
    } else {
      const targets = document.querySelectorAll('[data-target][data-target-scroll]');

      el = first(targets);
    }

    if (el) {
      el.scrollIntoView({ block, behavior });
    }
  }, [behavior, getTarget]);

  const isVisible = useCallback((target: string, parent: ParentElement = document) => !!getTarget(target, parent), [getTarget]);
  const focusTarget = useCallback((target: string, parent: ParentElement = document) => getTarget(target, parent)?.focus(), [getTarget]);

  return { focusTarget, getTarget, isVisible, scrollTo };
};
